import React, {useState} from "react";
import styled from "styled-components";
import {useNavigate} from "react-router-dom";
import {BASE_URL} from "../home/BASE_URL";
import {message} from "antd";

const Container = styled.div`
    min-height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f0f2f5;
`;

const Form = styled.form`
    background: white;
    padding: 40px;
    border-radius: 12px;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    width: 100%;
    max-width: 450px;
`;

const Title = styled.h2`
    margin-bottom: 25px;
    text-align: center;
    color: #722ed1;
`;

const Input = styled.input`
    width: 100%;
    padding: 12px;
    margin-bottom: 18px;
    border-radius: 6px;
    border: 1px solid #ddd;
    font-size: 16px;

    &: focus {
        border: 2px solid blue;
    }
`;

const Button = styled.button`
    width: 100%;
    padding: 12px;
    background: ${({disabled}) => (disabled ? "#bda5e6" : "#722ed1")};
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 16px;
    cursor: ${({disabled}) => (disabled ? "not-allowed" : "pointer")};
    transition: 0.2s ease;

    &:hover {
        background: ${({disabled}) => (disabled ? "#bda5e6" : "#5b1fb8")};
    }
`;

const PasswordWrapper = styled.div`
    position: relative;
    width: 100%;
`;

const TogglePassword = styled.span`
    position: absolute;
    right: 12px;
    top: 50%;
    transform: translateY(-120%);
    cursor: pointer;
    font-size: 14px;
    color: #722ed1;
    user-select: none;
`;

const AdminRegister = () => {
    const [form, setForm] = useState({
        UserName: "",
        email: "",
        password: "",
    });
    const [loading, setLoading] = useState(false);
    const [passwordOpen, setPasswordOpen] = useState(false);

    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const res = await fetch(`${BASE_URL}/admin/register`, {
                method: "POST",
                headers: {"Content-Type": "application/json"},
                body: JSON.stringify(form),
            });

            const data = await res.json();

            if (res.ok) {
                message.success("Admin registered successfully!");
                navigate("/login");
            } else {
                message.error(data.message || "Registration failed");
            }

            setLoading(true);
        } catch (error) {
            console.error("Registration error:", error);
            message.error("Server error");
        }
    };

    return (
        <Container>
            <Form onSubmit={handleSubmit}>
                <Title>Admin Register</Title>

                <Input
                    type="text"
                    placeholder="User Name"
                    value={form.UserName}
                    onChange={(e) => setForm({...form, UserName: e.target.value})}
                    required
                />
                <Input
                    type="email"
                    placeholder="Email"
                    value={form.email}
                    onChange={(e) => setForm({...form, email: e.target.value})}
                    required
                />
                <PasswordWrapper>
                    <Input
                        type={passwordOpen ? "text" : "password"}
                        placeholder="Password"
                        value={form.password}
                        onChange={(e) => setForm({...form, password: e.target.value})}
                        required
                    />

                    <TogglePassword onClick={() => setPasswordOpen(!passwordOpen)}>
                        {passwordOpen ? "Hide" : "Show"}
                    </TogglePassword>
                </PasswordWrapper>

                <Button type="submit" disabled={loading}>
                    {loading ? "Registering..." : "Register"}
                </Button>
            </Form>
        </Container>
    );
};

export default AdminRegister;
